import {AnimatedParticle, Emitter, OldEmitterConfig} from "pixi-particles";
import {ParticlesManager} from "../particles/ParticlesManager";
import {ParticleController} from "../particles/ParticleController";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {Game} from "../Game";

export class BigWinParticles extends PIXI.Container implements StageLayer {

    private readonly _fountainParticleConfigs: any[][] = [
        // all the same, change frequency in constructor.
        [
            {
                "alpha": {
                    "start": 1,
                    "end": 1
                },
                "scale": {
                    "start": 1.2,
                    "end": 1.4,
                    "minimumScaleMultiplier": 0.4
                },
                "color": {
                    "start": "#ffffff",
                    "end": "#ffffff"
                },
                "speed": {
                    "start": 850,
                    "end": 450,
                    "minimumSpeedMultiplier": 2
                },
                "acceleration": {
                    "x": 0,
                    "y": 2000
                },
                "maxSpeed": 0,
                "startRotation": {
                    "min": 240,
                    "max": 300
                },
                "noRotation": false,
                "rotationSpeed": {
                    "min": -400,
                    "max": 400
                },
                "lifetime": {
                    "min": 2,
                    "max": 2
                },
                "blendMode": "normal",
                "frequency": 0.1,
                "emitterLifetime": -1,
                "maxParticles": 200,
                "pos": {
                    "x": 0,
                    "y": 0,
                },
                "addAtBack": false,
                "spawnType": "rect",
                "spawnRect": {
                    "x": -25,
                    "y": 0,
                    "w": 50,
                    "h": 1
                }
            }
        ],
        [
            {
                "alpha": {
                    "start": 1,
                    "end": 1
                },
                "scale": {
                    "start": 1.2,
                    "end": 1.4,
                    "minimumScaleMultiplier": 0.4
                },
                "color": {
                    "start": "#ffffff",
                    "end": "#ffffff"
                },
                "speed": {
                    "start": 850,
                    "end": 450,
                    "minimumSpeedMultiplier": 2
                },
                "acceleration": {
                    "x": 0,
                    "y": 2000
                },
                "maxSpeed": 0,
                "startRotation": {
                    "min": 240,
                    "max": 300
                },
                "noRotation": false,
                "rotationSpeed": {
                    "min": -400,
                    "max": 400
                },
                "lifetime": {
                    "min": 2,
                    "max": 2
                },
                "blendMode": "normal",
                "frequency": 0.1,
                "emitterLifetime": -1,
                "maxParticles": 200,
                "pos": {
                    "x": 0,
                    "y": 0,
                },
                "addAtBack": false,
                "spawnType": "rect",
                "spawnRect": {
                    "x": -25,
                    "y": 0,
                    "w": 50,
                    "h": 1
                }
            },
            {
                "alpha": {
                    "start": 1,
                    "end": 1
                },
                "scale": {
                    "start": 1.2,
                    "end": 1.5,
                    "minimumScaleMultiplier": 0.6
                },
                "color": {
                    "start": "#ffffff",
                    "end": "#ffffff"
                },
                "speed": {
                    "start": 850,
                    "end": 450,
                    "minimumSpeedMultiplier": 2
                },
                "acceleration": {
                    "x": 0,
                    "y": 2000
                },
                "maxSpeed": 0,
                "startRotation": {
                    "min": 240,
                    "max": 300
                },
                "noRotation": false,
                "rotationSpeed": {
                    "min": -400,
                    "max": 400
                },
                "lifetime": {
                    "min": 2,
                    "max": 2
                },
                "blendMode": "normal",
                "frequency": 0.1,
                "emitterLifetime": -1,
                "maxParticles": 200,
                "pos": {
                    "x": 0,
                    "y": 0,
                },
                "addAtBack": false,
                "spawnType": "rect",
                "spawnRect": {
                    "x": -25,
                    "y": 0,
                    "w": 50,
                    "h": 1
                }
            }
        ],
        [
            {
                "alpha": {
                    "start": 1,
                    "end": 1
                },
                "scale": {
                    "start": 1.2,
                    "end": 1.4,
                    "minimumScaleMultiplier": 0.4
                },
                "color": {
                    "start": "#ffffff",
                    "end": "#ffffff"
                },
                "speed": {
                    "start": 850,
                    "end": 450,
                    "minimumSpeedMultiplier": 2
                },
                "acceleration": {
                    "x": 0,
                    "y": 2000
                },
                "maxSpeed": 0,
                "startRotation": {
                    "min": 240,
                    "max": 300
                },
                "noRotation": false,
                "rotationSpeed": {
                    "min": -400,
                    "max": 400
                },
                "lifetime": {
                    "min": 2,
                    "max": 2
                },
                "blendMode": "normal",
                "frequency": 0.1,
                "emitterLifetime": -1,
                "maxParticles": 200,
                "pos": {
                    "x": 0,
                    "y": 0,
                },
                "addAtBack": false,
                "spawnType": "rect",
                "spawnRect": {
                    "x": -25,
                    "y": 0,
                    "w": 50,
                    "h": 1
                }
            },
            {
                "alpha": {
                    "start": 1,
                    "end": 1
                },
                "scale": {
                    "start": 1.2,
                    "end": 1.5,
                    "minimumScaleMultiplier": 0.6
                },
                "color": {
                    "start": "#ffffff",
                    "end": "#ffffff"
                },
                "speed": {
                    "start": 850,
                    "end": 450,
                    "minimumSpeedMultiplier": 2
                },
                "acceleration": {
                    "x": 0,
                    "y": 2000
                },
                "maxSpeed": 0,
                "startRotation": {
                    "min": 240,
                    "max": 300
                },
                "noRotation": false,
                "rotationSpeed": {
                    "min": -400,
                    "max": 400
                },
                "lifetime": {
                    "min": 2,
                    "max": 2
                },
                "blendMode": "normal",
                "frequency": 0.1,
                "emitterLifetime": -1,
                "maxParticles": 200,
                "pos": {
                    "x": 0,
                    "y": 0,
                },
                "addAtBack": false,
                "spawnType": "rect",
                "spawnRect": {
                    "x": -25,
                    "y": 0,
                    "w": 50,
                    "h": 1
                }
            },
            {
                "alpha": {
                    "start": 1,
                    "end": 1
                },
                "scale": {
                    "start": 1.2,
                    "end": 1.3,
                    "minimumScaleMultiplier": 0.7
                },
                "color": {
                    "start": "#ffffff",
                    "end": "#ffffff"
                },
                "speed": {
                    "start": 850,
                    "end": 450,
                    "minimumSpeedMultiplier": 2
                },
                "acceleration": {
                    "x": 0,
                    "y": 2000
                },
                "maxSpeed": 0,
                "startRotation": {
                    "min": 240,
                    "max": 300
                },
                "noRotation": false,
                "rotationSpeed": {
                    "min": -400,
                    "max": 400
                },
                "lifetime": {
                    "min": 2,
                    "max": 2
                },
                "blendMode": "normal",
                "frequency": 0.1,
                "emitterLifetime": -1,
                "maxParticles": 200,
                "pos": {
                    "x": 0,
                    "y": 0,
                },
                "addAtBack": false,
                "spawnType": "rect",
                "spawnRect": {
                    "x": -25,
                    "y": 0,
                    "w": 50,
                    "h": 1
                }
            }
        ],
        [
            {
                "alpha": {
                    "start": 1,
                    "end": 1
                },
                "scale": {
                    "start": 1.2,
                    "end": 1.4,
                    "minimumScaleMultiplier": 0.4
                },
                "color": {
                    "start": "#ffffff",
                    "end": "#ffffff"
                },
                "speed": {
                    "start": 850,
                    "end": 450,
                    "minimumSpeedMultiplier": 2
                },
                "acceleration": {
                    "x": 0,
                    "y": 2000
                },
                "maxSpeed": 0,
                "startRotation": {
                    "min": 240,
                    "max": 300
                },
                "noRotation": false,
                "rotationSpeed": {
                    "min": -400,
                    "max": 400
                },
                "lifetime": {
                    "min": 2,
                    "max": 2
                },
                "blendMode": "normal",
                "frequency": 0.1,
                "emitterLifetime": -1,
                "maxParticles": 200,
                "pos": {
                    "x": 0,
                    "y": 0,
                },
                "addAtBack": false,
                "spawnType": "rect",
                "spawnRect": {
                    "x": -25,
                    "y": 0,
                    "w": 50,
                    "h": 1
                }
            },
            {
                "alpha": {
                    "start": 1,
                    "end": 1
                },
                "scale": {
                    "start": 1.2,
                    "end": 1.5,
                    "minimumScaleMultiplier": 0.6
                },
                "color": {
                    "start": "#ffffff",
                    "end": "#ffffff"
                },
                "speed": {
                    "start": 850,
                    "end": 450,
                    "minimumSpeedMultiplier": 2
                },
                "acceleration": {
                    "x": 0,
                    "y": 2000
                },
                "maxSpeed": 0,
                "startRotation": {
                    "min": 240,
                    "max": 300
                },
                "noRotation": false,
                "rotationSpeed": {
                    "min": -400,
                    "max": 400
                },
                "lifetime": {
                    "min": 2,
                    "max": 2
                },
                "blendMode": "normal",
                "frequency": 0.1,
                "emitterLifetime": -1,
                "maxParticles": 200,
                "pos": {
                    "x": 0,
                    "y": 0,
                },
                "addAtBack": false,
                "spawnType": "rect",
                "spawnRect": {
                    "x": -25,
                    "y": 0,
                    "w": 50,
                    "h": 1
                }
            },
            {
                "alpha": {
                    "start": 1,
                    "end": 1
                },
                "scale": {
                    "start": 1.2,
                    "end": 1.3,
                    "minimumScaleMultiplier": 0.7
                },
                "color": {
                    "start": "#ffffff",
                    "end": "#ffffff"
                },
                "speed": {
                    "start": 850,
                    "end": 450,
                    "minimumSpeedMultiplier": 2
                },
                "acceleration": {
                    "x": 0,
                    "y": 2000
                },
                "maxSpeed": 0,
                "startRotation": {
                    "min": 240,
                    "max": 300
                },
                "noRotation": false,
                "rotationSpeed": {
                    "min": -400,
                    "max": 400
                },
                "lifetime": {
                    "min": 2,
                    "max": 2
                },
                "blendMode": "normal",
                "frequency": 0.1,
                "emitterLifetime": -1,
                "maxParticles": 200,
                "pos": {
                    "x": 0,
                    "y": 0,
                },
                "addAtBack": false,
                "spawnType": "rect",
                "spawnRect": {
                    "x": -25,
                    "y": 0,
                    "w": 50,
                    "h": 1
                }
            },
            {
                "alpha": {
                    "start": 1,
                    "end": 1
                },
                "scale": {
                    "start": 1.1,
                    "end": 1.3,
                    "minimumScaleMultiplier": 0.8
                },
                "color": {
                    "start": "#ffffff",
                    "end": "#ffffff"
                },
                "speed": {
                    "start": 850,
                    "end": 450,
                    "minimumSpeedMultiplier": 2
                },
                "acceleration": {
                    "x": 0,
                    "y": 2000
                },
                "maxSpeed": 0,
                "startRotation": {
                    "min": 240,
                    "max": 300
                },
                "noRotation": false,
                "rotationSpeed": {
                    "min": -400,
                    "max": 400
                },
                "lifetime": {
                    "min": 2,
                    "max": 2
                },
                "blendMode": "normal",
                "frequency": 0.1,
                "emitterLifetime": -1,
                "maxParticles": 200,
                "pos": {
                    "x": 0,
                    "y": 0,
                },
                "addAtBack": false,
                "spawnType": "rect",
                "spawnRect": {
                    "x": -25,
                    "y": 0,
                    "w": 50,
                    "h": 1
                }
            }
        ],
        [
            {
                "alpha": {
                    "start": 1,
                    "end": 1
                },
                "scale": {
                    "start": 1.2,
                    "end": 1.4,
                    "minimumScaleMultiplier": 0.4
                },
                "color": {
                    "start": "#ffffff",
                    "end": "#ffffff"
                },
                "speed": {
                    "start": 850,
                    "end": 450,
                    "minimumSpeedMultiplier": 2
                },
                "acceleration": {
                    "x": 0,
                    "y": 2000
                },
                "maxSpeed": 0,
                "startRotation": {
                    "min": 240,
                    "max": 300
                },
                "noRotation": false,
                "rotationSpeed": {
                    "min": -400,
                    "max": 400
                },
                "lifetime": {
                    "min": 2,
                    "max": 2
                },
                "blendMode": "normal",
                "frequency": 0.1,
                "emitterLifetime": -1,
                "maxParticles": 200,
                "pos": {
                    "x": 0,
                    "y": 0,
                },
                "addAtBack": false,
                "spawnType": "rect",
                "spawnRect": {
                    "x": -25,
                    "y": 0,
                    "w": 50,
                    "h": 1
                }
            },
            {
                "alpha": {
                    "start": 1,
                    "end": 1
                },
                "scale": {
                    "start": 1.2,
                    "end": 1.5,
                    "minimumScaleMultiplier": 0.6
                },
                "color": {
                    "start": "#ffffff",
                    "end": "#ffffff"
                },
                "speed": {
                    "start": 850,
                    "end": 450,
                    "minimumSpeedMultiplier": 2
                },
                "acceleration": {
                    "x": 0,
                    "y": 2000
                },
                "maxSpeed": 0,
                "startRotation": {
                    "min": 240,
                    "max": 300
                },
                "noRotation": false,
                "rotationSpeed": {
                    "min": -400,
                    "max": 400
                },
                "lifetime": {
                    "min": 2,
                    "max": 2
                },
                "blendMode": "normal",
                "frequency": 0.1,
                "emitterLifetime": -1,
                "maxParticles": 200,
                "pos": {
                    "x": 0,
                    "y": 0,
                },
                "addAtBack": false,
                "spawnType": "rect",
                "spawnRect": {
                    "x": -25,
                    "y": 0,
                    "w": 50,
                    "h": 1
                }
            },
            {
                "alpha": {
                    "start": 1,
                    "end": 1
                },
                "scale": {
                    "start": 1.2,
                    "end": 1.4,
                    "minimumScaleMultiplier": 0.8
                },
                "color": {
                    "start": "#ffffff",
                    "end": "#ffffff"
                },
                "speed": {
                    "start": 850,
                    "end": 450,
                    "minimumSpeedMultiplier": 2
                },
                "acceleration": {
                    "x": 0,
                    "y": 2000
                },
                "maxSpeed": 0,
                "startRotation": {
                    "min": 240,
                    "max": 300
                },
                "noRotation": false,
                "rotationSpeed": {
                    "min": -400,
                    "max": 400
                },
                "lifetime": {
                    "min": 2,
                    "max": 2
                },
                "blendMode": "normal",
                "frequency": 0.1,
                "emitterLifetime": -1,
                "maxParticles": 200,
                "pos": {
                    "x": 0,
                    "y": 0,
                },
                "addAtBack": false,
                "spawnType": "rect",
                "spawnRect": {
                    "x": -25,
                    "y": 0,
                    "w": 50,
                    "h": 1
                }
            },
            {
                "alpha": {
                    "start": 1,
                    "end": 1
                },
                "scale": {
                    "start": 1.2,
                    "end": 1.4,
                    "minimumScaleMultiplier": 0.8
                },
                "color": {
                    "start": "#ffffff",
                    "end": "#ffffff"
                },
                "speed": {
                    "start": 850,
                    "end": 450,
                    "minimumSpeedMultiplier": 2
                },
                "acceleration": {
                    "x": 0,
                    "y": 2000
                },
                "maxSpeed": 0,
                "startRotation": {
                    "min": 240,
                    "max": 300
                },
                "noRotation": false,
                "rotationSpeed": {
                    "min": -400,
                    "max": 400
                },
                "lifetime": {
                    "min": 2,
                    "max": 2
                },
                "blendMode": "normal",
                "frequency": 0.1,
                "emitterLifetime": -1,
                "maxParticles": 200,
                "pos": {
                    "x": 0,
                    "y": 0,
                },
                "addAtBack": false,
                "spawnType": "rect",
                "spawnRect": {
                    "x": -25,
                    "y": 0,
                    "w": 50,
                    "h": 1
                }
            }
        ]
    ];
    private _fountainParticleTextures: string[][] = [
        ["particles/bullet_short/"],
        ["particles/bullet/"],
        ["particles/grenade/"],
        ["particles/dogtag/"],
    ];
    private _fountainParticleEmitters: Emitter[][] = [[], [], [], [], []];

    private _arrowFireParticles: ParticleController;
    private readonly _arrowFireEmitterConfig: OldEmitterConfig = {
        "alpha": {
            "start": 1,
            "end": 0.3
        },
        "scale": {
            "start": 0.5,
            "end": 1.2,
            "minimumScaleMultiplier": 0.3
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 3000,
            "end": 5000,
            "minimumSpeedMultiplier": 1
        },
        "acceleration": {
            "x": 0,
            "y": 0
        },
        "maxSpeed": 0,
        "startRotation": {
            "min": 70,
            "max": 100
        },
        "noRotation": false,
        "rotationSpeed": {
            "min": 0,
            "max": 20
        },
        "lifetime": {
            "min": 0.25,
            "max": 0.5
        },
        "blendMode": "add",
        "frequency": 0.1,
        "emitterLifetime": -1,
        "maxParticles": 5, //for maxParticle please refer "playArrowRain" method in "NormalBigWinPresentation"
        "pos": {
            "x": 0,
            "y": 0
        },
        "addAtBack": false,
        "spawnType": "rect",
        "spawnRect": {
            "x": -600,
            "y": -600,
            "w": 1920,
            "h": 600
        }
    };

    constructor() {
        super();
        this.setFountainParticlesFrequency();
        this._arrowFireParticles = new ParticleController(Game.bigWin, "Particles", this._arrowFireEmitterConfig);
        this._arrowFireParticles.setPos(new PIXI.Point(-360, -150));
        this._arrowFireParticles.update()
    }

    public play(level: number): void {
        this.stop();
        // forEach config and check if emitter exist. create and play.
        this._fountainParticleConfigs[level].forEach((config, i) => {
            if (!this._fountainParticleEmitters[level][i]) {
                const emitter: Emitter = new Emitter(this, this.getEmitterParticles(i).map(path => {
                    return {
                        framerate: 30,
                        loop: true,
                        hasLoaded: true,
                        textures: Game.assetLoader.getTextures(path)
                    }
                }), config);
                emitter.particleConstructor = AnimatedParticle;
                ParticlesManager.addEmitter(emitter, false);
                this._fountainParticleEmitters[level][i] = emitter;
            }
            this._fountainParticleEmitters[level][i].emit = true;
        });
        this.setMaxArrowParticles(level);
        this._arrowFireParticles.enableEmit(true);
    }

    public stop(): void {
        this._fountainParticleEmitters.forEach((levelEmitters: Emitter[]) => {
            levelEmitters.forEach(emitter => {
                if (emitter) {
                    emitter.emit = false;
                }
            });
        });
        this._arrowFireParticles.stopEmitter();
    }

    private getEmitterParticles(index: number): string[] {
        return this._fountainParticleTextures[index].concat();
    }

    private setFountainParticlesFrequency(): void {
        this._fountainParticleConfigs[0][0].frequency = 0.1;
        this._fountainParticleConfigs[1][0].frequency = 0.1;
        this._fountainParticleConfigs[1][1].frequency = 0.14;
        this._fountainParticleConfigs[2][0].frequency = 0.12;
        this._fountainParticleConfigs[2][1].frequency = 0.1;
        this._fountainParticleConfigs[3][0].frequency = 0.13;
        this._fountainParticleConfigs[3][1].frequency = 0.11;
        this._fountainParticleConfigs[3][2].frequency = 0.1;
        this._fountainParticleConfigs[4][0].frequency = 0.3;
        this._fountainParticleConfigs[4][1].frequency = 0.2;
        this._fountainParticleConfigs[4][2].frequency = 0.08;
    }

    private setMaxArrowParticles(level: number): void {
        let maxParticles: number;
        if (level === 0) {
            maxParticles = 33;
        } else if (level === 1) {
            maxParticles = 33;
        } else if (level === 2) {
            maxParticles = 33;
        } else if (level === 3) {
            maxParticles = 66;
        } else {
            maxParticles = 99;
        }
        this._arrowFireParticles.getEmitter().maxParticles = maxParticles;
    }
}
